import { axiosInstance } from "@/lib/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from '@/hooks/use-toast';

const userRemove = async (velId, userId:number) => {
  const { data } = await axiosInstance.delete(
    `/api/abo/vel/${velId}/user/${userId}`
  );
  return data;
};

export const useUserRemove = ({velId}) => {
  const {toast} = useToast();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (userId:number) => userRemove(velId, userId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['vel', velId, 'users'],
      });
      toast({
        variant: "default",
        title: "L'utilisateur a été supprimé",
      });
    },
    onError: () => {
      toast({
        title: "Il y a un problème",
        variant: "destructive",
      });
    },
  });
};
